import { render, staticRenderFns } from "./MeteorilogicalData.vue?vue&type=template&id=54cdad20&scoped=true"
import script from "./MeteorilogicalData.vue?vue&type=script&lang=js"
export * from "./MeteorilogicalData.vue?vue&type=script&lang=js"
import style0 from "./MeteorilogicalData.vue?vue&type=style&index=0&id=54cdad20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cdad20",
  null
  
)

export default component.exports